var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "#FDEDE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 67.166h14m-19.6-38.5h25.2c1.307 0 1.96 0 2.46.255.439.224.796.58 1.02 1.02.254.499.254 1.152.254 2.459v4.84c0 1.142 0 1.712-.13 2.25a4.667 4.667 0 0 1-.558 1.349c-.289.47-.692.874-1.5 1.681l-6.84 6.84c-.923.924-1.385 1.386-1.558 1.919a2.333 2.333 0 0 0 0 1.442c.173.533.635.995 1.559 1.919l6.84 6.84c.807.807 1.21 1.21 1.499 1.681.256.418.444.873.559 1.35.129.536.129 1.107.129 2.248v4.84c0 1.308 0 1.961-.255 2.46-.223.44-.58.796-1.02 1.02-.498.254-1.152.254-2.459.254H39.4c-1.306 0-1.96 0-2.459-.254a2.334 2.334 0 0 1-1.02-1.02c-.254-.499-.254-1.152-.254-2.46v-4.84c0-1.141 0-1.712.129-2.249.114-.476.303-.931.559-1.349.288-.47.692-.874 1.499-1.681l6.84-6.84c.924-.924 1.386-1.386 1.559-1.92a2.334 2.334 0 0 0 0-1.441c-.173-.533-.635-.995-1.56-1.919l-6.84-6.84c-.806-.807-1.21-1.21-1.498-1.681a4.667 4.667 0 0 1-.56-1.35c-.128-.536-.128-1.107-.128-2.249V32.4c0-1.307 0-1.96.254-2.46.224-.439.581-.796 1.02-1.02.5-.254 1.152-.254 2.46-.254Z",
    stroke: "#F26722",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHourglass;